// API_BASE_URL wird zur Build-Zeit über Vite-Env gesetzt (siehe .env.example
// im Repo-Root / docker-compose). Fällt im Dev-Server auf den Proxy-Pfad
// "/api/v1" zurück, den vite.config.ts auf den Backend-Container umleitet.
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '/api/v1';
